import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { images } from '../../../shared/assets/images';
import { useAuth } from '../../auth/context/AuthContext';

export default function HeroSection() {
  const location = useLocation();
  const successMessage = location.state?.successMessage || '';
  const { isAuthenticated } = useAuth();

  return (
    <section
      style={{ backgroundImage: `url(${images.homeBackground})` }}
      className="relative pt-24 items-center flex h-screen max-h-[860px] bg-cover bg-center bg-no-repeat"
      id="home"
    >
      {successMessage && (
        <div className="absolute top-24 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-md shadow-md z-20">
          {successMessage}
        </div>
      )}
      <div className="container mx-auto flex flex-wrap items-center px-4">
        <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12">
          <div className="pt-16 sm:pt-0 flex justify-center">
            <div className="bg-gray-200 border border-gray-200 rounded-2xl shadow-2xl p-8 sm:p-10 max-w-2xl transition-transform duration-700 hover:scale-[1.02] hover:shadow-2xl">
              <h2 className="text-4xl sm:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-yellow-600 to-orange-300 drop-shadow-md mb-6">
                Mundolandia Park
              </h2>
              <p className="text-base sm:text-lg text-gray-800 leading-relaxed tracking-wide">
                Ven y disfruta de la mejor experiencia en <strong>Mundolandia Park</strong>, un parque temático lleno de diversión y magia para toda la familia.
              </p>
              {!isAuthenticated && (
                <div className="mt-8 flex flex-wrap gap-4">
                  <Link
                    to={ROUTES.register}
                    className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-lg uppercase text-sm shadow-md transition-all duration-300"
                  >
                    Register
                  </Link>
                  <Link
                    to={ROUTES.voucherLookup}
                    className="bg-gray-700 hover:bg-gray-600 text-white font-semibold px-6 py-3 rounded-lg uppercase text-sm shadow-md transition-all duration-300"
                  >
                    Consultar bono
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-full md:w-4/12 lg:w-6/12 xl:w-6/12 mt-10 md:mt-0 flex justify-center">
          <img src={images.logo} alt="Parque Mundolandia" className="max-w-full h-auto rounded-lg shadow-lg" />
        </div>
      </div>
    </section>
  );
}
